import { ApplicationExceptionHandler } from "@gtpl/shared-utils/error-messages";
import { Body, Controller, Post } from "@nestjs/common";
import { ApiTags } from "@nestjs/swagger";
import { RmBudgetService } from "./rm-budget.service";
import { RmBudgetResponseModel } from "@gtpl/shared-models/masters";
import { RmBudgetInfoReq } from "@gtpl/shared-models/raw-material-procurement";


@ApiTags('rmBudget')
@Controller('rmBudget')
export class RmBudgetController {
    constructor(
        private service: RmBudgetService,
        private readonly applicationExceptionHandler: ApplicationExceptionHandler) {
    }
    @Post('/createRmBudget')
    async createRmBudget(@Body() data:any): Promise<RmBudgetResponseModel>{
       try{
        return this.service.createRmBudget(data);
       } catch(err){
        return this.applicationExceptionHandler.returnException(RmBudgetResponseModel,err);
       }
    }
    @Post('/getAllRmBudget')
    async getAllRmBudget(): Promise<RmBudgetResponseModel>{
       try{
        return this.service.getAllRmBudget();
       } catch(err){
        return this.applicationExceptionHandler.returnException(RmBudgetResponseModel,err);
       }
    }
    @Post('/getBudgetRangeAgainstCount')
    async getBudgetRangeAgainstCount(@Body() req:RmBudgetInfoReq): Promise<RmBudgetResponseModel>{
       try{
        return this.service.getBudgetRangeAgainstCount(req);
       } catch(err){
        return this.applicationExceptionHandler.returnException(RmBudgetResponseModel,err);
       }
    }
}